import React, { memo, useCallback } from 'react';
import { BaseConfirmDialog } from 'reactApp/components/BaseConfirmDialog/BaseConfirmDialog';
import { EButtonType } from 'reactApp/components/BaseConfirmDialog/BaseConformationDialog.types';

import styles from './ViolatedFilename.css';

export interface IProps {
    onClose: () => void;
    fileName: string;
}

const BUTTONS = [EButtonType.cancel];

export const ViolatedFilenameDialog = memo<IProps>(({ onClose, fileName }) => {
    const renderHeader = useCallback(() => 'Ошибка при загрузке файла', []);
    const renderContent = useCallback(
        () => (
            <div>
                Файл <b>{fileName}</b> не&nbsp;может быть загружен в&nbsp;хранилище в&nbsp;соответствии с&nbsp;правиламами безопасности.
                Обратитесь к&nbsp;администратору
            </div>
        ),
        [fileName]
    );

    return (
        <BaseConfirmDialog
            dataQAId="violated-filename-dialog"
            renderHeader={renderHeader}
            onClose={onClose}
            renderContent={renderContent}
            closeOnDimmerClick
            buttons={BUTTONS}
            className={styles.root}
            cancelButtonText="Закрыть"
        />
    );
});

ViolatedFilenameDialog.displayName = 'ViolatedFilenameDialog';
